export class HRConfigAccess {
  hrConfigId:      string;
  employeeId:      string;
  active:          boolean = true;
  fullName: string;
}
